export default __webpack_public_path__ + "static/media/Usluga-4-FASADE.7af77ef4.jpg";